// extracted by mini-css-extract-plugin
export default {"imageContainerDiv":"ViewItemModal_imageContainerDiv__l6Uj0","modalScrollableBody":"ViewItemModal_modalScrollableBody__VUJJh"};